<template>
  <v-card
    ref="item"
    class="proxer-project-card d-flex justify-space-between"
  >
    <div class="select-checkbox px-2 d-flex flex-column justify-center">
      <v-checkbox v-model="isSelectedProject" @change="selectAll" class="mt-0 card-select" hide-details />
    </div>
    <div class="card px-4 py-3">
      <v-row class="mx-0 pa-0 mb-3">
        <div class="card-title col-2 ma-0 pa-0">{{ proxerData.projectTitle }}</div>
        <div class="mr-10"><b>Proxy Service:</b> {{ proxyProvider }}</div>
        <div><b>Proxy launcher country:</b> {{ targetCountry }}</div>
      </v-row>
      <div class="card-content">
        <div class="card-image">
          <img src="" />
        </div>
        <div class="card-systems">
          <div
            v-for="(systemBrandConfiguration, index) in proxerData.systemBrandConfigs.slice(0, maxShowProviders)"
            :key="systemBrandConfiguration.accesslist_id"
            class="system-brand-config d-flex mb-2 px-4 justify-space-between"
          >
            <v-checkbox v-model="systemBrandConfiguration.isSelected" @change="(systems) => selectSystem(systemBrandConfiguration)" />
            <div class="content d-flex pa-3" style="gap: 5rem;">
              <div class="config-img">
                <img width="65" height="65" :src="urlImgBrand(systemBrandConfiguration.brandAlias)" onerror="this.style.display='none'">
              </div>
              <div class="config d-flex flex-column">
                <div class="section-title">
                  System:
                </div>
                <div class="config-title">
                  {{ systemBrandConfiguration.system }}
                </div>
              </div>
              <div class="config d-flex flex-column">
                <div class="section-title">
                  Brand:
                </div>
                <div class="config-title">
                  {{ systemBrandConfiguration.brand }}
                </div>
              </div>
              <div class="config d-flex flex-column">
                <div class="section-title">
                  Proxied countries:
                </div>
                <lang-row
                  class="pl-4"
                  :countries="systemBrandConfiguration.countries"
                />
              </div>
            </div>
            <v-switch
              :input-value="systemBrandConfiguration.is_enabled"
              :value="systemBrandConfiguration.is_enabled"
              @change="(value) => updateProxer({key: 'is_enabled', value: {status: Boolean(value), provider: systemBrandConfiguration}})"
            />
          </div>

          <div
            class="d-flex justify-end"
            v-if="proxerData.systemBrandConfigs.length > 2"
          >
            <v-btn
              @click="expandListOfProviders"
              color="primary"
              outlined
            >
              <span v-if="!isExpanded">+ {{ proxerData.systemBrandConfigs.length - 2 }} Brands: Show All</span>
              <span v-else>Brands: Collapse</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="actions px-3 d-flex flex-column justify-space-between pt-4 pb-3 px-3">
      <div class="up d-flex flex-column align-center">
        <v-switch
          :input-value="isEnabledCard"
          :value="isEnabledCard"
          @mousedown="(value) => updateProxer({key: 'status', value: {status: !isEnabledCard}, all: true})"
          class="mt-0"
          ref="testInput"
          hide-details
        />
        <v-btn
          icon
          @click.stop="$emit('edit')">
          <v-icon>
            mdi-tune
          </v-icon>
        </v-btn>
        <export
          v-bind="exportBaseProps"
          :verticalDirection="true"
        />
      </div>
      <!--      <div class="down d-flex justify-center">-->
      <!--        <v-btn icon @click="">-->
      <!--          <v-icon>mdi-delete-outline</v-icon>-->
      <!--        </v-btn>-->
      <!--      </div>-->
    </div>
  </v-card>
</template>

<script>
  import LangRow from '@/components/core/SelectLang/LangRow/LangRow.vue'
  import { find } from 'lodash'
  import Export from '@/components/helper/Export.vue'
  import { PROXER_EXPORT_FIELDS } from '@/modules/proxers/constants/exportFields'

  export default {
    components: { Export, LangRow },
    data: () => ({
      isSelectedProject: false,
      selectedSystems: [],
      isExpanded: false,
      maxShowProviders: 2,
      isConfirmation: false,
      exportFields: PROXER_EXPORT_FIELDS,
    }),
    props: {
      providerList: {
        type: Array,
        require: true
      },
      proxerData: {
        type: Object,
        default: () => ({})
      },
      bulkedProxer: {
        type: Array,
        default: () => []
      },
    },
    methods: {
      selectSystem (systemBrand) {
        this.$emit('selectSystems', { item: systemBrand, added: systemBrand.isSelected })
      },
      expandListOfProviders () {
        this.isExpanded = !this.isExpanded
        if (!this.isExpanded) {
          this.$nextTick(() => {
            const firstVisibleItem = this.$refs.item?.$el

            if (firstVisibleItem) {
              const itemPosition = firstVisibleItem.getBoundingClientRect().top + window.scrollY
              const scrollPosition = itemPosition - 15
              window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
              })
            }
          })
        }
      },
      async updateProxer ({ key, value, all }) {
        if (all && !await this.$root.$confirm('Confirm', value.status ? 'Enable Proxies' : 'Disable Proxies')) {
          return
        }
        const data = {
          entity_id: this.proxerData.entity_id
        }
        if (key === 'is_enabled') {
          const foundProvider = this.proxerData.systemBrandConfigs.find(provider => provider === value.provider)
          foundProvider.is_enabled = value.status
          data.params = {
            brand_id: foundProvider.brand_id
          }

        } else {
          this.proxerData.systemBrandConfigs = this.proxerData.systemBrandConfigs.map((config) => ({ ...config, is_enabled: value.status }))
          data.params = {
            all: true//value.status
          }
        }

        data.key = value.status
        data.proxerData = this.proxerData

        this.$emit('switchProxerStatus', data)
      },
      selectAll (flag) {
        for (let config of this.proxerData.systemBrandConfigs) {
          config.isSelected = this.isSelectedProject ? true : false
        }
        this.$emit('selectAll', { flag, proxer: this.proxerData.systemBrandConfigs })
      },
    },
    computed: {
      proxyProvider () {
        return (find(this.providerList, { proxy_provider_id: this.proxerData.systemBrandConfigs[0].proxy_provider_id }) || {}).name
      },
      targetCountry () {
        return this.proxerData.systemBrandConfigs[0].target_country
      },
      urlImgBrand () {
        return (systemAlias) => `https://altacdn.com/${this.proxerData.prefix}/img/brands/${systemAlias}_logo.svg`
      },
      isEnabledCard () {
        return this.proxerData.systemBrandConfigs.some(config => config.is_enabled === true)
      },
      exportBaseProps () {
        return {
          data: this.proxerData.systemBrandConfigs.filter(item => item.is_enabled),
          fields: this.exportFields,
          project: this.proxerData.entity_id,
          reportName: `${this.proxerData.projectTitle} proxer settings`,
          without_sg: true
        }
      },
    },
    watch: {
      isExpanded: {
        handler () {
          this.maxShowProviders = this.isExpanded ? this.proxerData.systemBrandConfigs.length : 2
        }
      },
      bulkedProxer: {
        handler (items) {
          this.selectedSystems = items

          const isEnableAll = _.every(this.proxerData.systemBrandConfigs, (config) => {
            return _.some(items, (item) => {
              return item === config
            })
          })
          this.isSelectedProject = isEnableAll
        },
        deep: true,
        immediate: true,
      },
    },

  }
</script>

<style lang="scss" scoped>
  .proxer-project-card {
    --border-color: #e0e0e0;
    --title-color: #546272;

    .select-checkbox {
      border-right: 1px solid var(--border-color);

      .card-select {
        ::v-deep .v-input--selection-controls__input {
          margin-right: 0;
        }
      }
    }

    .card {
      width: 100%;

      &-title {
        color: #546272;
        font-weight: bold;
      }

      .card-content {
        display: flex;
        gap: 16px;

        .card-image {
          flex: 0 0 15%;
          height: 140px;
          background-color: #d5d5d5;
        }

        .card-systems {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 100%;

          .system-brand-config {
            border: 1px solid var(--border-color);
            border-radius: 4px;

            .content {
              width: 100%;

              .config {
                width: 150px;

                &-title {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }

                &-img {
                  background-color: #d5d5d5;
                  width: 65px;
                  height: 65px;
                }

              }

              .section-title {
                color: var(--title-color);
                font-weight: bold;
              }
            }
          }
        }
      }
    }

    .actions {
      border-left: 1px solid var(--border-color);
    }
  }
</style>
